"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayersListCtl = /** @class */ (function (_super) {
    __extends(PlayersListCtl, _super);
    function PlayersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.login; });
        _this.dk_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.name; });
        _this.dk_surname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.surname; });
        _this.dk_fathername = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fathername; });
        _this.dk_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email; });
        _this.dk_phone = UIUtils_1.UIUtils.IProp2Str(function (o) { o.phone; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_is_email_confirmed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_email_confirmed; });
        _this.dk_is_phone_confirmed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_phone_confirmed; });
        _this.dk_birthday_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_day; });
        _this.dk_birthday_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_month; });
        _this.dk_birthday_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_year; });
        _this.dk_is_verifed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_verifed; });
        _this.dk_is_cards_allowed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_cards_allowed; });
        _this.dk_sex = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sex; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_money_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.money_balance; });
        _this.dk_points_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.points_balance; });
        _this.dk_bonus_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_balance; });
        _this.dk_bonus_level_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_level_id; });
        _this.dk_bonus_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_level_title; });
        _this.dk_is_bot = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_bot; });
        _this.dk_is_self_exclude = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_self_exclude; });
        _this.dk_self_exclude_date = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_date; });
        _this.dk_self_exclude_till_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_till_year; });
        _this.dk_self_exclude_till_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_till_month; });
        _this.dk_self_exclude_till_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_till_day; });
        _this.dk_self_exclude_till_hour = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_till_hour; });
        _this.dk_self_exclude_till_minute = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_till_minute; });
        _this.dk_self_exclude_till_second = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_exclude_till_second; });
        _this.dk_is_self_deposit_week_limit = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_self_deposit_week_limit; });
        _this.dk_self_deposit_week_limit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.self_deposit_week_limit_amount; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_country = UIUtils_1.UIUtils.IProp2Str(function (o) { o.country; });
        _this.dk_city = UIUtils_1.UIUtils.IProp2Str(function (o) { o.city; });
        _this.dk_address = UIUtils_1.UIUtils.IProp2Str(function (o) { o.address; });
        _this.dk_is_use_affilate = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_use_affilate; });
        _this.dk_affilate_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_id; });
        _this.dk_affilate_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_title; });
        _this.dk_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_id; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_partner_offer_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_offer_id; });
        _this.dk_partner_offer_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_offer_title; });
        _this.dk_is_use_tracker = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_use_tracker; });
        _this.dk_partner_tracker_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_tracker_id; });
        _this.dk_partner_tracker_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_tracker_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_total_bet_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_bet_amount; });
        _this.dk_is_agree_on_email_subscription = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_agree_on_email_subscription; });
        _this.dk_is_streamer = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_streamer; });
        _this.dk_is_developer = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_developer; });
        _this.dk_profit_status_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.profit_status_code; });
        _this.dk_profit_status_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.profit_status_title; });
        _this.dk_is_ignore_ip_withdrawal_check = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_ignore_ip_withdrawal_check; });
        _this.dk_trust_zone_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_code; });
        _this.dk_trust_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_title; });
        _this.dk_trust_zone_color = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_color; });
        _this.dk_is_trust_zone_static = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_trust_zone_static; });
        _this.dk_time_zone_offset_hours = UIUtils_1.UIUtils.IProp2Str(function (o) { o.time_zone_offset_hours; });
        _this.dk_by_ip_city = UIUtils_1.UIUtils.IProp2Str(function (o) { o.by_ip_city; });
        _this.dk_by_ip_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.by_ip_country_code; });
        _this.dk_by_ip_organisation = UIUtils_1.UIUtils.IProp2Str(function (o) { o.by_ip_organisation; });
        _this.dk_is_ignore_firewall_processing = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_ignore_firewall_processing; });
        _this.dk_is_suspicious = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_suspicious; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            currency_filter: [],
            language_filter: [],
            level_filter: []
        };
    };
    PlayersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayersListCtl.prototype.LoadData = function (allBrands, brandIdList, allTags, tagIdList, Offset, Limit, onDone) {
        var _this = this;
        webAApi_1.ListPlayersByBrandIdGetEx.exec({
            all_brands: allBrands,
            brand_id_list: brandIdList,
            all_tags: allTags,
            tags_id_list: tagIdList,
            offset: Offset,
            limit: Limit
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.currency_filter = [];
            var currency_filter_map = new Map();
            //
            _this.DATA.language_filter = [];
            var language_filter_map = new Map();
            //
            _this.DATA.level_filter = [];
            var level_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!currency_filter_map.get(resp.list[i].currency_title)) {
                    _this.DATA.currency_filter.push({ text: resp.list[i].currency_title, value: resp.list[i].currency_title });
                    currency_filter_map.set(resp.list[i].currency_title, resp.list[i].currency_title);
                }
                if (!language_filter_map.get(resp.list[i].language_title)) {
                    _this.DATA.language_filter.push({ text: resp.list[i].language_title, value: resp.list[i].language_title });
                    language_filter_map.set(resp.list[i].language_title, resp.list[i].language_title);
                }
                if (!level_filter_map.get(resp.list[i].bonus_level_title)) {
                    _this.DATA.level_filter.push({ text: resp.list[i].bonus_level_title, value: resp.list[i].bonus_level_title });
                    level_filter_map.set(resp.list[i].bonus_level_title, resp.list[i].bonus_level_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    login: resp.list[i].login,
                    name: resp.list[i].name,
                    surname: resp.list[i].surname,
                    fathername: resp.list[i].fathername,
                    email: resp.list[i].email,
                    phone: resp.list[i].phone,
                    is_locked: resp.list[i].is_locked,
                    is_email_confirmed: resp.list[i].is_email_confirmed,
                    is_phone_confirmed: resp.list[i].is_phone_confirmed,
                    birthday_day: resp.list[i].birthday_day,
                    birthday_month: resp.list[i].birthday_month,
                    birthday_year: resp.list[i].birthday_year,
                    is_verifed: resp.list[i].is_verifed,
                    is_cards_allowed: resp.list[i].is_cards_allowed,
                    sex: resp.list[i].sex,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    app_currency_id: resp.list[i].currency_id,
                    app_currency_title: resp.list[i].currency_title,
                    money_balance: resp.list[i].money_balance,
                    points_balance: resp.list[i].points_balance,
                    bonus_balance: resp.list[i].bonus_balance,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    player_tags: resp.list[i].player_tags,
                    app_language_id: resp.list[i].language_id,
                    app_language_title: resp.list[i].language_title,
                    bonus_level_id: resp.list[i].bonus_level_id,
                    bonus_level_title: resp.list[i].bonus_level_title,
                    is_bot: resp.list[i].is_bot,
                    is_self_exclude: resp.list[i].is_self_exclude,
                    self_exclude_date: moment(resp.list[i].self_exclude_date_uts_ms).utc(false),
                    self_exclude_till_year: resp.list[i].self_exclude_till_year,
                    self_exclude_till_month: resp.list[i].self_exclude_till_month,
                    self_exclude_till_day: resp.list[i].self_exclude_till_day,
                    self_exclude_till_hour: resp.list[i].self_exclude_till_hour,
                    self_exclude_till_minute: resp.list[i].self_exclude_till_minute,
                    self_exclude_till_second: resp.list[i].self_exclude_till_second,
                    is_self_deposit_week_limit: resp.list[i].is_self_deposit_week_limit,
                    self_deposit_week_limit_amount: resp.list[i].self_deposit_week_limit_amount,
                    description: resp.list[i].description,
                    country: resp.list[i].country,
                    city: resp.list[i].city,
                    address: resp.list[i].address,
                    is_use_affilate: resp.list[i].is_use_affilate,
                    affilate_id: resp.list[i].affilate_id,
                    affilate_title: resp.list[i].affilate_title,
                    partner_id: resp.list[i].partner_id,
                    partner_login: resp.list[i].partner_login,
                    partner_offer_id: resp.list[i].partner_offer_id,
                    partner_offer_title: resp.list[i].partner_offer_title,
                    is_use_tracker: resp.list[i].is_use_tracker,
                    partner_tracker_id: resp.list[i].partner_tracker_id,
                    partner_tracker_title: resp.list[i].partner_tracker_title,
                    total_bet_amount: resp.list[i].total_bet_amount,
                    is_agree_on_email_subscription: resp.list[i].is_agree_on_email_subscription,
                    is_streamer: resp.list[i].is_streamer,
                    is_custom_zone: resp.list[i].is_custom_zone,
                    custom_gameprovider_zone_id: resp.list[i].custom_gameprovider_zone_id,
                    custom_gameprovider_zone_title: resp.list[i].custom_gameprovider_zone_title,
                    is_developer: resp.list[i].is_developer,
                    profit_status_code: resp.list[i].profit_status_code,
                    profit_status_title: resp.list[i].profit_status_title,
                    is_disable_profit_status_select: resp.list[i].is_disable_profit_status_select,
                    is_ignore_ip_withdrawal_check: resp.list[i].is_ignore_ip_withdrawal_check,
                    trust_zone_code: resp.list[i].trust_zone_code,
                    trust_zone_title: resp.list[i].trust_zone_title,
                    is_trust_zone_static: resp.list[i].is_trust_zone_static,
                    time_zone_offset_hours: resp.list[i].time_zone_offset_hours,
                    by_ip_city: resp.list[i].by_ip_city,
                    by_ip_country_code: resp.list[i].by_ip_country_code,
                    by_ip_organisation: resp.list[i].by_ip_organisation,
                    is_ignore_firewall_processing: resp.list[i].is_ignore_firewall_processing,
                    trust_zone_color: resp.list[i].trust_zone_color,
                    is_suspicious: resp.list[i].is_suspicious
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.LoadFilteredData = function (filter, onDone) {
        var _this = this;
        webAApi_1.ListPlayersByFiltersGet.exec({
            all_brands: filter.allBrands,
            brand_id_list: filter.brandIdList,
            all_tags: filter.allTags,
            tags_id_list: filter.tagIdList,
            is_filter_email_part: filter.isFilterEmailPart,
            email_part: filter.emailPart,
            is_filter_login_part: filter.isFilterLoginPart,
            login_part: filter.loginPart,
            offset: filter.Offset,
            limit: filter.Limit
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.currency_filter = [];
            var currency_filter_map = new Map();
            //
            _this.DATA.language_filter = [];
            var language_filter_map = new Map();
            //
            _this.DATA.level_filter = [];
            var level_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!currency_filter_map.get(resp.list[i].currency_title)) {
                    _this.DATA.currency_filter.push({ text: resp.list[i].currency_title, value: resp.list[i].currency_title });
                    currency_filter_map.set(resp.list[i].currency_title, resp.list[i].currency_title);
                }
                if (!language_filter_map.get(resp.list[i].language_title)) {
                    _this.DATA.language_filter.push({ text: resp.list[i].language_title, value: resp.list[i].language_title });
                    language_filter_map.set(resp.list[i].language_title, resp.list[i].language_title);
                }
                if (!level_filter_map.get(resp.list[i].bonus_level_title)) {
                    _this.DATA.level_filter.push({ text: resp.list[i].bonus_level_title, value: resp.list[i].bonus_level_title });
                    level_filter_map.set(resp.list[i].bonus_level_title, resp.list[i].bonus_level_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    login: resp.list[i].login,
                    name: resp.list[i].name,
                    surname: resp.list[i].surname,
                    fathername: resp.list[i].fathername,
                    email: resp.list[i].email,
                    phone: resp.list[i].phone,
                    is_locked: resp.list[i].is_locked,
                    is_email_confirmed: resp.list[i].is_email_confirmed,
                    is_phone_confirmed: resp.list[i].is_phone_confirmed,
                    birthday_day: resp.list[i].birthday_day,
                    birthday_month: resp.list[i].birthday_month,
                    birthday_year: resp.list[i].birthday_year,
                    is_verifed: resp.list[i].is_verifed,
                    is_cards_allowed: resp.list[i].is_cards_allowed,
                    sex: resp.list[i].sex,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    app_currency_id: resp.list[i].currency_id,
                    app_currency_title: resp.list[i].currency_title,
                    money_balance: resp.list[i].money_balance,
                    points_balance: resp.list[i].points_balance,
                    bonus_balance: resp.list[i].bonus_balance,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    player_tags: resp.list[i].player_tags,
                    app_language_id: resp.list[i].language_id,
                    app_language_title: resp.list[i].language_title,
                    bonus_level_id: resp.list[i].bonus_level_id,
                    bonus_level_title: resp.list[i].bonus_level_title,
                    is_bot: resp.list[i].is_bot,
                    is_self_exclude: resp.list[i].is_self_exclude,
                    self_exclude_date: moment(resp.list[i].self_exclude_date_uts_ms).utc(false),
                    self_exclude_till_year: resp.list[i].self_exclude_till_year,
                    self_exclude_till_month: resp.list[i].self_exclude_till_month,
                    self_exclude_till_day: resp.list[i].self_exclude_till_day,
                    self_exclude_till_hour: resp.list[i].self_exclude_till_hour,
                    self_exclude_till_minute: resp.list[i].self_exclude_till_minute,
                    self_exclude_till_second: resp.list[i].self_exclude_till_second,
                    is_self_deposit_week_limit: resp.list[i].is_self_deposit_week_limit,
                    self_deposit_week_limit_amount: resp.list[i].self_deposit_week_limit_amount,
                    description: resp.list[i].description,
                    country: resp.list[i].country,
                    city: resp.list[i].city,
                    address: resp.list[i].address,
                    is_use_affilate: resp.list[i].is_use_affilate,
                    affilate_id: resp.list[i].affilate_id,
                    affilate_title: resp.list[i].affilate_title,
                    partner_id: resp.list[i].partner_id,
                    partner_login: resp.list[i].partner_login,
                    partner_offer_id: resp.list[i].partner_offer_id,
                    partner_offer_title: resp.list[i].partner_offer_title,
                    is_use_tracker: resp.list[i].is_use_tracker,
                    partner_tracker_id: resp.list[i].partner_tracker_id,
                    partner_tracker_title: resp.list[i].partner_tracker_title,
                    total_bet_amount: resp.list[i].total_bet_amount,
                    is_agree_on_email_subscription: resp.list[i].is_agree_on_email_subscription,
                    is_streamer: resp.list[i].is_streamer,
                    is_custom_zone: resp.list[i].is_custom_zone,
                    custom_gameprovider_zone_id: resp.list[i].custom_gameprovider_zone_id,
                    custom_gameprovider_zone_title: resp.list[i].custom_gameprovider_zone_title,
                    is_developer: resp.list[i].is_developer,
                    profit_status_code: resp.list[i].profit_status_code,
                    profit_status_title: resp.list[i].profit_status_title,
                    is_disable_profit_status_select: resp.list[i].is_disable_profit_status_select,
                    is_ignore_ip_withdrawal_check: resp.list[i].is_ignore_ip_withdrawal_check,
                    trust_zone_code: resp.list[i].trust_zone_code,
                    trust_zone_title: resp.list[i].trust_zone_title,
                    trust_zone_color: resp.list[i].trust_zone_color,
                    is_trust_zone_static: resp.list[i].is_trust_zone_static,
                    time_zone_offset_hours: resp.list[i].time_zone_offset_hours,
                    by_ip_city: resp.list[i].by_ip_city,
                    by_ip_country_code: resp.list[i].by_ip_country_code,
                    by_ip_organisation: resp.list[i].by_ip_organisation,
                    is_ignore_firewall_processing: resp.list[i].is_ignore_firewall_processing,
                    is_suspicious: resp.list[i].is_suspicious
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.AddPlayer = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPlayer.exec({
            brand_id: data.brand_id,
            app_currency_id: data.currency_id,
            login: data.login,
            password: data.password,
            name: data.name,
            surname: data.surname,
            fathername: data.fathername,
            email: data.email,
            phone: data.phone,
            is_locked: data.is_locked,
            is_email_confirmed: data.is_email_confirmed,
            is_phone_confirmed: data.is_phone_confirmed,
            birthday_day: data.birthday_day,
            birthday_month: data.birthday_month,
            birthday_year: data.birthday_year,
            is_verifed: data.is_verifed,
            is_cards_allowed: data.is_cards_allowed,
            sex: data.sex,
            app_language_id: data.language_id,
            is_bot: data.is_bot,
            is_self_exclude: data.is_self_exclude,
            self_exclude_till_year: data.self_exclude_till_year,
            self_exclude_till_month: data.self_exclude_till_month,
            self_exclude_till_day: data.self_exclude_till_day,
            self_exclude_till_hour: data.self_exclude_till_hour,
            self_exclude_till_minute: data.self_exclude_till_minute,
            self_exclude_till_second: data.self_exclude_till_second,
            is_self_deposit_week_limit: data.is_self_deposit_week_limit,
            self_deposit_week_limit_amount: data.self_deposit_week_limit_amount,
            description: data.description,
            country: data.country,
            city: data.city,
            address: data.address,
            is_use_affilate: data.is_use_affilate,
            affilate_id: data.affilate_id,
            partner_id: data.partner_id,
            partner_offer_id: data.partner_offer_id,
            is_use_tracker: data.is_use_tracker,
            partner_tracker_id: data.partner_tracker_id,
            is_agree_on_email_subscription: data.is_agree_on_email_subscription,
            is_streamer: data.is_streamer,
            is_custom_zone: data.is_custom_zone,
            custom_gameprovider_zone_id: data.custom_gameprovider_zone_id,
            is_developer: data.is_developer,
            profit_status_code: data.profit_status_code,
            is_ignore_ip_withdrawal_check: data.is_ignore_ip_withdrawal_check,
            trust_zone_code: data.trust_zone_code,
            is_trust_zone_static: data.is_trust_zone_static,
            is_ignore_firewall_processing: data.is_ignore_firewall_processing,
            is_suspicious: data.is_suspicious
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                login: data.login,
                name: data.name,
                surname: data.surname,
                fathername: data.fathername,
                email: data.email,
                phone: data.phone,
                is_locked: data.is_locked,
                is_email_confirmed: data.is_email_confirmed,
                is_phone_confirmed: data.is_phone_confirmed,
                birthday_day: data.birthday_day,
                birthday_month: data.birthday_month,
                birthday_year: data.birthday_year,
                is_verifed: data.is_verifed,
                is_cards_allowed: data.is_cards_allowed,
                sex: data.sex,
                points_balance: resp.points_balance,
                money_balance: resp.money_balance,
                bonus_balance: resp.bonus_balance,
                app_currency_id: data.currency_id,
                app_currency_title: resp.app_currency_title,
                // affilate_id: data.affilate_id,
                // affilate_title: resp.affilate_title,
                player_tags: [],
                app_language_id: data.language_id,
                app_language_title: resp.app_language_title,
                bonus_level_id: resp.bonus_level_id,
                bonus_level_title: resp.bonus_level_title,
                is_bot: data.is_bot,
                is_self_exclude: data.is_self_exclude,
                self_exclude_till_year: data.self_exclude_till_year,
                self_exclude_till_month: data.self_exclude_till_month,
                self_exclude_till_day: data.self_exclude_till_day,
                self_exclude_till_hour: data.self_exclude_till_hour,
                self_exclude_till_minute: data.self_exclude_till_minute,
                self_exclude_till_second: data.self_exclude_till_second,
                is_self_deposit_week_limit: data.is_self_deposit_week_limit,
                self_deposit_week_limit_amount: data.self_deposit_week_limit_amount,
                description: data.description,
                self_exclude_date: moment(resp.date_self_exclude_uts_ms).utc(false),
                country: data.country,
                city: data.city,
                address: data.address,
                is_use_affilate: data.is_use_affilate,
                affilate_id: data.affilate_id,
                affilate_title: resp.affilate_title,
                partner_id: data.partner_id,
                partner_login: resp.partner_login,
                partner_offer_id: data.partner_offer_id,
                partner_offer_title: resp.partner_offer_title,
                is_use_tracker: data.is_use_tracker,
                partner_tracker_id: data.partner_tracker_id,
                partner_tracker_title: resp.partner_tracker_title,
                total_bet_amount: 0,
                is_agree_on_email_subscription: data.is_agree_on_email_subscription,
                is_streamer: data.is_streamer,
                is_custom_zone: data.is_custom_zone,
                custom_gameprovider_zone_id: data.custom_gameprovider_zone_id,
                custom_gameprovider_zone_title: resp.custom_gameprovider_zone_title,
                is_developer: data.is_developer,
                profit_status_code: data.profit_status_code,
                profit_status_title: resp.profit_status_title,
                is_disable_profit_status_select: resp.is_disable_profit_status_select,
                is_ignore_ip_withdrawal_check: data.is_ignore_ip_withdrawal_check,
                is_trust_zone_static: data.is_trust_zone_static,
                trust_zone_code: data.trust_zone_code,
                trust_zone_title: resp.trust_zone_title,
                trust_zone_color: resp.trust_zone_color,
                time_zone_offset_hours: 3,
                by_ip_city: "-",
                by_ip_country_code: "-",
                by_ip_organisation: "-",
                is_ignore_firewall_processing: data.is_ignore_firewall_processing,
                is_suspicious: data.is_suspicious
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.EditPlayer = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPlayer.exec({
                player_id: data.key,
                name: data.name,
                surname: data.surname,
                fathername: data.fathername,
                email: data.email,
                phone: data.phone,
                is_locked: data.is_locked,
                is_email_confirmed: data.is_email_confirmed,
                is_phone_confirmed: data.is_phone_confirmed,
                birthday_day: data.birthday_day,
                birthday_month: data.birthday_month,
                birthday_year: data.birthday_year,
                is_verifed: data.is_verifed,
                is_cards_allowed: data.is_cards_allowed,
                sex: data.sex,
                is_self_exclude: data.is_self_exclude,
                self_exclude_till_year: data.self_exclude_till_year,
                self_exclude_till_month: data.self_exclude_till_month,
                self_exclude_till_day: data.self_exclude_till_day,
                self_exclude_till_hour: data.self_exclude_till_hour,
                self_exclude_till_minute: data.self_exclude_till_minute,
                self_exclude_till_second: data.self_exclude_till_second,
                is_self_deposit_week_limit: data.is_self_deposit_week_limit,
                self_deposit_week_limit_amount: data.self_deposit_week_limit_amount,
                description: data.description,
                app_language_id: data.language_id,
                country: data.country,
                city: data.city,
                address: data.address,
                is_use_affilate: data.is_use_affilate,
                affilate_id: data.affilate_id,
                partner_id: data.partner_id,
                partner_offer_id: data.partner_offer_id,
                is_use_tracker: data.is_use_tracker,
                partner_tracker_id: data.partner_tracker_id,
                is_agree_on_email_subscription: data.is_agree_on_email_subscription,
                is_streamer: data.is_streamer,
                is_custom_zone: data.is_custom_zone,
                custom_gameprovider_zone_id: data.custom_gameprovider_zone_id,
                is_developer: data.is_developer,
                profit_status_code: data.profit_status_code,
                is_ignore_ip_withdrawal_check: data.is_ignore_ip_withdrawal_check,
                trust_zone_code: data.trust_zone_code,
                is_trust_zone_static: data.is_trust_zone_static,
                is_ignore_firewall_processing: data.is_ignore_firewall_processing,
                is_suspicious: data.is_suspicious
            }, function (resp) {
                _tmp.name = data.name;
                _tmp.surname = data.surname;
                _tmp.fathername = data.fathername;
                _tmp.email = data.email;
                _tmp.phone = data.phone;
                _tmp.is_locked = data.is_locked;
                _tmp.is_email_confirmed = data.is_email_confirmed;
                _tmp.is_phone_confirmed = data.is_phone_confirmed;
                _tmp.birthday_day = data.birthday_day;
                _tmp.birthday_month = data.birthday_month;
                _tmp.birthday_year = data.birthday_year;
                _tmp.is_verifed = data.is_verifed;
                _tmp.is_cards_allowed = data.is_cards_allowed;
                _tmp.sex = data.sex;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_self_exclude = data.is_self_exclude;
                _tmp.self_exclude_till_year = data.self_exclude_till_year;
                _tmp.self_exclude_till_month = data.self_exclude_till_month;
                _tmp.self_exclude_till_day = data.self_exclude_till_day;
                _tmp.self_exclude_till_hour = data.self_exclude_till_hour;
                _tmp.self_exclude_till_minute = data.self_exclude_till_minute;
                _tmp.self_exclude_till_second = data.self_exclude_till_second;
                _tmp.is_self_deposit_week_limit = data.is_self_deposit_week_limit;
                _tmp.self_deposit_week_limit_amount = data.self_deposit_week_limit_amount;
                _tmp.self_exclude_date = moment(resp.date_self_exclude_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.country = data.country;
                _tmp.city = data.city;
                _tmp.address = data.address;
                _tmp.app_language_id = data.language_id;
                _tmp.app_language_title = resp.language_title;
                _tmp.is_use_affilate = data.is_use_affilate;
                _tmp.affilate_id = data.affilate_id;
                _tmp.partner_id = data.partner_id;
                _tmp.partner_offer_id = data.partner_offer_id;
                _tmp.is_use_tracker = data.is_use_tracker;
                _tmp.partner_tracker_id = data.partner_tracker_id;
                _tmp.is_agree_on_email_subscription = data.is_agree_on_email_subscription;
                _tmp.is_streamer = data.is_streamer;
                _tmp.is_custom_zone = data.is_custom_zone;
                _tmp.custom_gameprovider_zone_id = data.custom_gameprovider_zone_id;
                _tmp.custom_gameprovider_zone_title = resp.custom_gameprovider_zone_title;
                _tmp.is_developer = data.is_developer;
                _tmp.profit_status_code = data.profit_status_code;
                _tmp.profit_status_title = resp.profit_status_title;
                _tmp.is_disable_profit_status_select = resp.is_disable_profit_status_select;
                _tmp.is_ignore_ip_withdrawal_check = data.is_ignore_ip_withdrawal_check;
                _tmp.trust_zone_code = data.trust_zone_code;
                _tmp.trust_zone_title = resp.trust_zone_title;
                _tmp.trust_zone_color = resp.trust_zone_color;
                _tmp.is_trust_zone_static = data.is_trust_zone_static;
                _tmp.is_ignore_firewall_processing = data.is_ignore_firewall_processing;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.DeletePlayer = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePlayer.exec({
                usr_player_id: key,
            }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.GetPlayerPassword = function (key, onDone) {
        var _this = this;
        webAApi_1.DoGetPlayerPassword.exec({ player_id: key }, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.GeneratePlayerPassword = function (onDone) {
        var _this = this;
        webAApi_1.DoGeneratePlayerPassword.exec({}, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.SetPlayerIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerIsLocked.exec({
                player_id: key,
                is_locked: IsLocked
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.SetPlayerNewPassword = function (key, newPassword, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerNewPassword.exec({
                player_id: key,
                new_password: newPassword
            }, function (resp) {
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.doDepositMoneyToPlayer = function (key, depositAmount, depositDescription, tag, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoManualPlayerDepositCreate.exec({
                data: {
                    usr_player_id: key,
                    amount: depositAmount,
                    description: depositDescription,
                    gws_tag: tag
                }
            }, function (resp) {
                _tmp.money_balance = resp.balance_money_after;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.doWithdrawMoneyFromPlayer = function (key, withdrawAmount, withdrawtDescription, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoManualPlayerWithdrawCreate.exec({
                data: {
                    usr_player_id: key,
                    amount: withdrawAmount,
                    description: withdrawtDescription
                }
            }, function (resp) {
                _tmp.money_balance = resp.balance_money_after;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.doChangePlayerStreamerBalance = function (key, newAmount, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoPlayerStreamerChangeBalance.exec({
                data: {
                    usr_player_id: key,
                    amount: newAmount,
                }
            }, function (resp) {
                _tmp.money_balance = resp.balance_money_after;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayersListCtl.prototype.doExportObjectArray = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        var _data = [];
        webAApi_1.DoExportPlayersList.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            for (var i = 0; i < resp.list.length; i++) {
                _data.push({
                    id: resp.list[i].key_uid,
                    brand: resp.list[i].brand_title,
                    email: resp.list[i].email,
                    login: resp.list[i].login
                });
            }
            if (onDone) {
                onDone(_data);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.doExportSubscribedObjectArray = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        var _data = [];
        webAApi_1.DoExportPlayersSubscribersList.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            for (var i = 0; i < resp.list.length; i++) {
                _data.push({
                    id: resp.list[i].key_uid,
                    brand: resp.list[i].brand_title,
                    email: resp.list[i].email,
                    login: resp.list[i].login
                });
            }
            if (onDone) {
                onDone(_data);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.doExportRawArray = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        var _data = [];
        webAApi_1.DoExportPlayersList.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            for (var i = 0; i < resp.list.length; i++) {
                var _tmp = [];
                _tmp.push(resp.list[i].key_uid);
                _tmp.push(resp.list[i].brand_title);
                _tmp.push(resp.list[i].email);
                _tmp.push(resp.list[i].login);
                _data.push(_tmp);
            }
            if (onDone) {
                onDone(_data);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayersListCtl.prototype.doUpdatePlayerLevels = function (onDone) {
        var _this = this;
        var _data = [];
        webAApi_1.DoUpdatePlayersBonusLevels.exec({}, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PlayersListCtl;
}(BaseController_1.BaseController));
exports.PlayersListCtl = PlayersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayersListCtl.ts
// module id = 869
// module chunks = 0